import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "row" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-5 font-weight-400 mt-3" }, "Endereço"),
    /*#__PURE__*/ _createElementVNode("hr")
], -1);
const _hoisted_3 = { class: "col-12" };
const _hoisted_4 = { class: "form-group" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Cep", -1);
const _hoisted_6 = { class: "col-8" };
const _hoisted_7 = { class: "form-group" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Endereço", -1);
const _hoisted_9 = ["disabled"];
const _hoisted_10 = { class: "col-4" };
const _hoisted_11 = { class: "form-group" };
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Número", -1);
const _hoisted_13 = ["disabled"];
const _hoisted_14 = { class: "col-6" };
const _hoisted_15 = { class: "form-group" };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("label", null, "Complemento", -1);
const _hoisted_17 = ["disabled"];
const _hoisted_18 = { class: "col-6" };
const _hoisted_19 = { class: "form-group" };
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Bairro", -1);
const _hoisted_21 = ["disabled"];
const _hoisted_22 = { class: "col-6" };
const _hoisted_23 = { class: "form-group" };
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "UF", -1);
const _hoisted_25 = { class: "col-6" };
const _hoisted_26 = { class: "form-group" };
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Cidade", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_InputMasked = _resolveComponent("InputMasked");
    const _component_SelectUf = _resolveComponent("SelectUf");
    const _component_AutocompleteGenerico = _resolveComponent("AutocompleteGenerico");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_InputMasked, {
                    modelValue: _ctx.user.cep,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.user.cep) = $event)),
                    onChange: _cache[1] || (_cache[1] = ($event) => (_ctx.changeCep())),
                    mask: "#####-###",
                    disabled: !_ctx.podeAlterar
                }, null, 8, ["modelValue", "disabled"])
            ])
        ]),
        _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    required: "",
                    placeholder: "Endereço",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.user.logradouro) = $event)),
                    disabled: !_ctx.podeAlterar
                }, null, 8, _hoisted_9), [
                    [_vModelText, _ctx.user.logradouro]
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    required: "",
                    placeholder: "Número",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.user.numero) = $event)),
                    disabled: !_ctx.podeAlterar,
                    maxlength: "10"
                }, null, 8, _hoisted_13), [
                    [_vModelText, _ctx.user.numero]
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    placeholder: "Complemento",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.user.complemento) = $event)),
                    disabled: !_ctx.podeAlterar
                }, null, 8, _hoisted_17), [
                    [_vModelText, _ctx.user.complemento]
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    required: "",
                    placeholder: "Bairro",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.user.bairro) = $event)),
                    disabled: !_ctx.podeAlterar
                }, null, 8, _hoisted_21), [
                    [_vModelText, _ctx.user.bairro]
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createVNode(_component_SelectUf, {
                    modelValue: _ctx.user.uf,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.user.uf) = $event)),
                    required: "",
                    disabled: !_ctx.podeAlterar
                }, null, 8, ["modelValue", "disabled"])
            ])
        ]),
        _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createVNode(_component_AutocompleteGenerico, {
                    modelValue: _ctx.user.municipio_id,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.user.municipio_id) = $event)),
                    url: "/municipios/autocomplete",
                    "text-alias": "municipio",
                    placeholder: "Cidade onde você mora",
                    required: "",
                    disabled: !_ctx.podeAlterar,
                    pesquisaAdicional: {
                        uf: _ctx.user.uf,
                    }
                }, null, 8, ["modelValue", "disabled", "pesquisaAdicional"])
            ])
        ])
    ]));
}
